<script lang="ts" setup>
	type uiConfig = {
		wrapper: {
			default?: string
			spacing?: string
		}
		title: Partial<{
			default: string
			size: string
			color: string
			font: string
			highlight: Partial<{
				color: string
			}>
		}>
		subTitle: Partial<{
			default: string
			size: string
			color: string
		}>
	}

	withDefaults(
		defineProps<{
			title?: string
			highlight?: string
			subTitle?: string
			titleClass?: ClassContext
			subTitleClass?: ClassContext
			wrapperClass?: ClassContext
			ui?: Partial<uiConfig>
		}>(),
		{
			subTitle: '',
			subTitleClass: 'text-sm',
			wrapperClass: 'md:space-y-4 space-y-2'
		}
	)
	const {
		subTitle: subTitleCls,
		title: titleCls,
		wrapper
	}: uiConfig = {
		wrapper: {
			default: '',
			spacing: 'md:space-y-4 space-y-2'
		},
		title: {
			default: 'tracking-wide',
			size: 'md:text-[26px]  text-2xl',
			color: 'text-blue-950',
			font: 'font-semibold',
			highlight: {
				color: 'text-primary-2'
			}
		},
		subTitle: {
			default: 'tracking-wide',
			size: 'md:text-base text-sm',
			color: 'text-gray-500'
		}
	}
</script>

<template>
	<header :class="wrapperClass">
		<h1
			:class="[
				titleClass,
				ui?.title?.default ?? titleCls.default,
				ui?.title?.color ?? titleCls.color,
				ui?.title?.font ?? titleCls.font,
				ui?.title?.size ?? titleCls.size
			]"
		>
			<slot name="title">
				{{ title }}
				<span v-show="highlight" :class="[ui?.title?.highlight?.color]">
					{{ highlight }}
				</span>
			</slot>
		</h1>

		<p
			:class="[
				subTitleClass,
				ui?.subTitle?.default ?? subTitleCls.default,
				ui?.subTitle?.size ?? subTitleCls.size,
				ui?.subTitle?.color ?? subTitleCls.color
			]"
		>
			<slot name="subTitle">
				<span v-html="subTitle"></span>
			</slot>
		</p>
	</header>
</template>
